import React from 'react'
import PropTypes from 'prop-types'
import { CreateChat } from './CreateChat'

export const ChatSidebar = ({
  isLocalEnvironment,
  activateChatFunc,
  setActiveChat,
  activeChat,
  authDetails,
  envData,
  getData,
  getChatData,
}) => {
  const [createChat, setCreateChat] = React.useState(false)
  const [createGroupChat, setCreateGroupChat] = React.useState(false)

  const getChatNewMessages = (chatId) => {
    const myChatsData =
      (sessionStorage.getItem('myChats') && JSON.parse(sessionStorage.getItem('myChats'))) || null
    if (myChatsData === null) {
      return 0
    }
    let activeChats
    if (myChatsData !== null) {
      activeChats = myChatsData.filter((f) => f.data.chatId === chatId)
    }
    if (activeChats.length && activeChats.length > 0) {
      const result = activeChats[0].new === 0 ? '' : activeChats[0].new
      setActiveChat(activeChat)
      return result
    }
  }

  const urlPath = window.location.pathname
  const urlLink = urlPath.split('/organization/')
  return (
    <>
      <div className="trtui-chat-leftsidebar">
        <div className="trtui-px-4 trtui-pt-4 trtui-mb-3">
          <div className="trtui-d-flex trtui-align-items-start">
            <div className="trtui-flex-grow-1">
              <h5 className="trtui-mb-4">Messages</h5>
            </div>
          </div>
        </div>
        <div
          className="trtui-tab-content trtui-text-muted cScrollBar"
          style={{ maxHeight: '100vh' }}
        >
          <div className="trtui-tab-pane trtui-active" id="chats" role="tabpanel">
            <div className="trtui-chat-room-list trtui-pt-3" data-simplebar="init">
              <div className="trtui-d-flex trtui-align-items-center trtui-px-4 trtui-mb-2">
                <div className="trtui-flex-grow-1">
                  <h6 className="trtui-mb-0 fs-11 trtui-text-muted trtui-text-uppercase">
                    Messages
                  </h6>
                </div>
                <div className="trtui-flex-shrink-0">
                  <div
                    data-bs-toggle="tooltip"
                    data-bs-trigger="hover"
                    data-bs-placement="bottom"
                    aria-label="New Message"
                    data-bs-original-title="New Message"
                  >
                    <button
                      type="button"
                      className="trtui-btn trtui-btn-soft-primary trtui-btn-sm shadow-none"
                      onClick={() => setCreateChat(true, true)}
                    >
                      <i className="ri-add-line trtui-align-bottom" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="trtui-chat-message-list">
                <ul
                  className="trtui-list-unstyled trtui-chat-list trtui-chat-user-list"
                  id="userList"
                >
                  {authDetails.role === 'Staff' ||
                  authDetails.role === 'Office Staff' ||
                  authDetails.role === 'Staff Admin' ||
                  authDetails.orgRole === 'Staff' ||
                  authDetails.orgRole === 'Office Staff' ||
                  authDetails.orgRole === 'Staff Admin'
                    ? getChatData.data?.formData &&
                      getChatData.data?.formData.length > 0 &&
                      getChatData.data?.formData
                        .filter((f) => f.isGroupChat !== 1)
                        .map((c, cInd) => (
                          <li
                            key={cInd}
                            id="contact-id-1"
                            data-name="direct-message"
                            className={
                              activeChat !== null && activeChat.id && activeChat.id === c._id
                                ? 'trtui-active'
                                : ''
                            }
                          >
                            <a onClick={() => activateChatFunc(c)} href="#!">
                              <div className="trtui-d-flex trtui-align-items-center">
                                <div className="trtui-flex-shrink-0 trtui-chat-user-img trtui-online trtui-align-self-center trtui-me-2 trtui-ms-0">
                                  <div className="trtui-avatar-xxs">
                                    <div className="trtui-avatar-title trtui-rounded-circle trtui-bg-primary trtui-text-white trtui-fs-10">
                                      #
                                    </div>
                                    <span className="trtui-user-status" />
                                  </div>
                                </div>
                                <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                                  <p className="trtui-text-truncate trtui-mb-0">{c.chatSubject}</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        ))
                    : getData.data?.formData &&
                      getData.data?.formData.length > 0 &&
                      getData.data?.formData
                        .filter((f) => f.isGroupChat !== 1)
                        .map((c, cInd) => (
                          <li
                            key={cInd}
                            id="contact-id-1"
                            data-name="direct-message"
                            className={
                              activeChat !== null && activeChat.id && activeChat.id === c._id
                                ? 'trtui-active'
                                : ''
                            }
                          >
                            <a onClick={() => activateChatFunc(c)} href="#!">
                              <div className="trtui-d-flex trtui-align-items-center">
                                <div className="trtui-flex-shrink-0 trtui-chat-user-img trtui-online trtui-align-self-center trtui-me-2 trtui-ms-0">
                                  <div className="trtui-avatar-xxs">
                                    <div className="trtui-avatar-title trtui-rounded-circle trtui-bg-primary trtui-text-white trtui-fs-10">
                                      #
                                    </div>
                                    <span className="trtui-user-status" />
                                  </div>
                                </div>
                                <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                                  <p className="trtui-text-truncate trtui-mb-0">{c.chatSubject}</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        ))}
                </ul>
              </div>
              <div className="trtui-d-flex trtui-align-items-center trtui-px-4 trtui-mt-4 trtui-pt-2 trtui-mb-2">
                <div className="trtui-flex-grow-1">
                  <h4 className="trtui-mb-0 trtui-fs-11 trtui-text-muted trtui-text-uppercase">
                    Groups
                  </h4>
                </div>
                {urlLink.length > 1 &&
                  (authDetails.orgRole === 'Staff' ||
                    authDetails.orgRole === 'Office Staff' ||
                    authDetails.orgRole === 'Staff Admin') && (
                    <div className="trtui-flex-shrink-0">
                      <div
                        data-bs-toggle="tooltip"
                        data-bs-trigger="hover"
                        data-bs-placement="bottom"
                        aria-label="Create group"
                        data-bs-original-title="Create group"
                      >
                        <button
                          type="button"
                          className="trtui-btn trtui-btn-soft-success trtui-btn-sm"
                          onClick={() => setCreateGroupChat(true)}
                        >
                          <i className="ri-add-line trtui-align-bottom" />
                        </button>
                      </div>
                    </div>
                  )}
                {(authDetails.role === 'Staff' ||
                  authDetails.role === 'Office Staff' ||
                  authDetails.role === 'Staff Admin') && (
                  <div className="trtui-flex-shrink-0">
                    <div
                      data-bs-toggle="tooltip"
                      data-bs-trigger="hover"
                      data-bs-placement="bottom"
                      aria-label="Create group"
                      data-bs-original-title="Create group"
                    >
                      <button
                        type="button"
                        className="trtui-btn trtui-btn-soft-success trtui-btn-sm"
                        onClick={() => setCreateGroupChat(true)}
                      >
                        <i className="ri-add-line trtui-align-bottom" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="trtui-chat-message-list">
                <ul
                  className="trtui-list-unstyled trtui-chat-list trtui-chat-user-list trtui-mb-0"
                  id="channelList"
                >
                  {getData.data?.formData &&
                    getData.data?.formData.length > 0 &&
                    getData.data?.formData
                      .filter((f) => f.isGroupChat === 1)
                      .map((c, cInd) => (
                        <li
                          key={cInd}
                          id="contact-id-10"
                          data-name="channel"
                          className={
                            activeChat !== null && activeChat.chatId === c.chatId
                              ? 'trtui-active'
                              : ''
                          }
                        >
                          <a
                            onClick={() => activateChatFunc(c, true)}
                            href="#!"
                            className="trtui-unread-msg-user"
                          >
                            <div className="trtui-d-flex trtui-align-items-center">
                              <div className="trtui-flex-shrink-0 trtui-chat-user-img trtui-align-self-center trtui-me-2 trtui-ms-0">
                                <div className="trtui-avatar-xxs">
                                  <div className="trtui-avatar-title trtui-bg-light trtui-rounded-circle trtui-text-body">
                                    #
                                  </div>
                                </div>
                              </div>
                              <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                                <p className="trtui-text-truncate trtui-mb-0">{c.chatSubject}</p>
                              </div>
                              <div>
                                <div className="trtui-flex-shrink-0 trtui-ms-2">
                                  <span className="trtui-badge trtui-bg-dark-subtle trtui-text-body trtui-rounded trtui-p-1">
                                    {getChatNewMessages(c.chatId)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </li>
                      ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="trtui-tab-pane" id="contacts" role="tabpanel">
            <div className="trtui-chat-room-list trtui-pt-3" data-simplebar="init">
              <div className="trtui-sort-contact">
                <div className="trtui-mt-3">
                  <div className="trtui-contact-list-title">A </div>
                  <ul id="contact-sort-A" className="trtui-list-unstyled trtui-contact-list">
                    <li>
                      <div className="trtui-d-flex trtui-align-items-center">
                        <div className="trtui-flex-shrink-0 trtui-me-2">
                          <div className="trtui-avatar-xxs">
                            <span className="trtui-avatar-title trtui-rounded-circle trtui-bg-primary trtui-fs-10">
                              AC
                            </span>
                          </div>
                        </div>
                        <div className="trtui-flex-grow-1">
                          <p className="trtui-text-truncate trtui-contactlist-name trtui-mb-0">
                            Alice Cruickshank
                          </p>
                        </div>
                        <div className="trtui-flex-shrink-0">
                          <div className="trtui-dropdown">
                            <a
                              href="#"
                              className="trtui-text-muted"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="ri-more-2-fill" />
                            </a>
                            <div className="trtui-dropdown-menu trtui-dropdown-menu-end">
                              <a className="trtui-dropdown-item" href="#">
                                <i className="ri-pencil-line trtui-text-muted trtui-me-2 align-bottom" />
                                Edit
                              </a>
                              <a className="trtui-dropdown-item" href="#">
                                <i className="ri-forbid-2-line trtui-text-muted trtui-me-2 trtui-align-bottom" />
                                Block
                              </a>
                              <a className="trtui-dropdown-item" href="#">
                                <i className="ri-delete-bin-6-line trtui-text-muted trtui-me-2 trtui-align-bottom" />
                                Remove
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="trtui-mt-3">
                  <div className="trtui-contact-list-title">B </div>
                  <ul id="contact-sort-B" className="trtui-list-unstyled trtui-contact-list">
                    <li>
                      <div className="trtui-d-flex trtui-align-items-center">
                        <div className="trtui-flex-shrink-0 trtui-me-2">
                          <div className="trtui-avatar-xxs">
                            <img
                              src="assets/images/users/avatar-4.jpg"
                              className="trtui-img-fluid trtui-rounded-circle"
                            />
                          </div>
                        </div>
                        <div className="trtui-flex-grow-1">
                          <p className="trtui-text-truncate trtui-contactlist-name trtui-mb-0">
                            Barrett Brown
                          </p>
                        </div>
                        <div className="trtui-flex-shrink-0">
                          <div className="trtui-dropdown">
                            <a
                              href="#"
                              className="trtui-text-muted"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="ri-more-2-fill" />
                            </a>
                            <div className="trtui-dropdown-menu trtui-dropdown-menu-end">
                              <a className="trtui-dropdown-item" href="#">
                                <i className="ri-pencil-line trtui-text-muted trtui-me-2 trtui-align-bottom" />
                                Edit
                              </a>
                              <a className="dropdown-item" href="#">
                                <i className="ri-forbid-2-line trtui-text-muted trtui-me-2 trtui-align-bottom" />
                                Block
                              </a>
                              <a className="dropdown-item" href="#">
                                <i className="ri-delete-bin-6-line trtui-text-muted trtui-me-2 trtui-align-bottom" />
                                Remove
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {createGroupChat && (
        <CreateChat
          isLocalEnvironment={isLocalEnvironment}
          authDetails={authDetails}
          envData={envData}
          setNewMessageModal={setCreateGroupChat}
          isGroupChat={true}
        />
      )}
      {createChat && (
        <CreateChat
          isLocalEnvironment={isLocalEnvironment}
          authDetails={authDetails}
          envData={envData}
          setNewMessageModal={setCreateChat}
        />
      )}
    </>
  )
}

ChatSidebar.propTypes = {
  isLocalEnvironment: PropTypes.string,
  activateChatFunc: PropTypes.func,
  setActiveChat: PropTypes.func,
  activeChat: PropTypes.object,
  authDetails: PropTypes.object,
  envData: PropTypes.object,
  getData: PropTypes.object,
  getChatData: PropTypes.object,
}
